module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.isEmptyAnnouncement() && _vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.announcementHTMLWithSafeLinks)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading || _vm.hasBeenRedirected) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.isThereAnyUpcomingTransaction) ? _c('div', {
    staticClass: "alert alert-info mb-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Click "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UpcomingTransactionsForInvestor'
      },
      "title": "Upcoming Transactions",
      "replace": ""
    }
  }, [_vm._v("here")]), _vm._v(" to see the transactions you need to provide direction on.")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "welcome text-center"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "welcome-options"
  }, [_c('button', {
    staticClass: "card card-create",
    attrs: {
      "role": "link"
    },
    on: {
      "click": _vm.goToAccountCreation
    }
  }, [_c('em', {
    staticClass: "icon-user-follow card-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Create a new account")]), _vm._v(" "), _c('p', [_vm._v("Let's create an account with just three easy steps.")])])])]) : _vm._e(), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've purchased a Community Investment Note!",
      "subtitle": "Your investment will take 3 to 4 business days to be processed. You will receive a notification when it's completed.",
      "closeAction": _vm.hidePurchaseCompletedAlert,
      "isShowing": _vm.showPurchaseCompleted
    }
  }), _vm._v(" "), (_vm.hasBeenCreatedAccount) ? _c('div', [_c('div', {
    staticClass: "row-space-around"
  }, [_c('div', {
    staticClass: "current-balance"
  }, [_c('p', {
    staticClass: "msg text-muted panel-title mt-lg mb-lg"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.currentAmountBalance))])])]), _vm._v(" "), (!_vm.disableInvestment && (_vm.userStatus && _vm.userStatus.status === 'verified') && !_vm.isInstitutionAccount && !_vm.isReadOnly) ? _c('button', {
    staticClass: "btn btn-default btn-lg m-vertical btn-full-mobile",
    attrs: {
      "type": "submit",
      "data-toggle": "tooltip",
      "data-placement": "top"
    },
    on: {
      "click": _vm.goToNotePurchase
    }
  }, [_vm._v("\n                  Make an investment\n              ")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "panel-title mt-lg mb-lg"
  }, [_vm._v("Here are your last 45 days of transactions:")]), _vm._v(" "), (_vm.transactions.length > 0) ? _c('div', {
    staticClass: "transactions-container"
  }, [_c('div', {
    staticClass: "transactions-table-desktop",
    class: {
      'table-fixed-header--md cols-5': _vm.transactions.length > 8, 'condensed': _vm.isThereAnyUpcomingTransaction
    }
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(t, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(t.note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [(_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "transactions-cards-mobile"
  }, _vm._l((_vm.transactions), function(t, index) {
    return _c('div', {
      key: index,
      staticClass: "transaction-card"
    }, [_c('div', {
      staticClass: "transaction-card-header"
    }, [_c('div', {
      staticClass: "transaction-card-date"
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), (_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-body"
    }, [_c('div', {
      staticClass: "transaction-card-row"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Transaction type:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))])]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-row"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Note number:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(t.note.noteId))])]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-row transaction-card-amount"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Amount:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))])])])])
  }))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "updates-content"
  }, _vm._l((Object.values(_vm.summaryPageDocuments).filter(Boolean)), function(d, index) {
    return _c('button', {
      key: ("Card" + index),
      staticClass: "card card-update card-update-content",
      attrs: {
        "role": "link"
      },
      on: {
        "click": function($event) {
          _vm.openDocument(d)
        }
      }
    }, [_c('img', {
      staticClass: "card-icon",
      attrs: {
        "src": _vm.getIconUrl(d.icon, d.iconName),
        "alt": "icon",
        "height": "100"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(d.tag))])])
  }))]) : _vm._e()])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account summary\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon icon-info pr-sm"
  }), _vm._v("Please note that you have upcoming transactions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "welcome-header"
  }, [_c('h2', {
    staticClass: "welcome-title"
  }, [_vm._v("Thanks for registering!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "welcome-paragraph"
  }, [_c('strong', [_vm._v("Welcome to Calvert Impact Capital's investment platform.")]), _c('br'), _vm._v("We invite you to "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "aria-describedby": "new-window-0",
      "href": "https://www.calvertimpactcapital.org/about"
    }
  }, [_vm._v("learn about our work "), _c('em', {
    staticClass: "fa fa fa-external-link"
  })]), _vm._v(". And when you're ready, proceed to create a new account.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "updates-header"
  }, [_c('h3', {
    staticClass: "panel-title mt-lg mb-lg"
  }, [_vm._v("Investor updates")]), _vm._v(" "), _c('h3', {
    staticClass: "panel-title mt-lg mb-lg latest-updates"
  }, [_c('a', {
    staticClass: "btn-right icon-right bottom-margin",
    attrs: {
      "href": "http://www.calvertimpactcapital.org/blog",
      "target": "_blank"
    }
  }, [_vm._v("\n                  See Latest Calvert Impact Capital Updates\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6334279b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountSummary.vue
// module id = 2160
// module chunks = 1